import React, { useEffect } from 'react';
import { useOutletContext, useLocation } from 'react-router-dom';
import Hero from '../components/Hero';
import TrustStrip from '../components/TrustStrip';
import VideoSection from '../components/VideoSection';
import About from '../components/About';
import Services from '../components/Services';
import FreedomSection from '../components/FreedomSection';
import HowItWorks from '../components/HowItWorks';
import Team from '../components/Team';
import Signs from '../components/Signs';
import WhyChooseUs from '../components/WhyChooseUs';
import Testimonials from '../components/Testimonials';
import StatsBand from '../components/StatsBand';
import Faq from '../components/Faq';
import CtaSection from '../components/CtaSection';
import useReveal from '../hooks/useReveal';

export default function Home() {
  const { openSchedule } = useOutletContext();
  const location = useLocation();
  useReveal();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0 });
    }
  }, [location.hash]);

  return (
    <>
      <Hero onSchedule={openSchedule} />
      <TrustStrip />
      <VideoSection />
      <About />
      <Services onSchedule={openSchedule} />
      <FreedomSection onSchedule={openSchedule} />
      <HowItWorks />
      <Team />
      <Signs onSchedule={openSchedule} />
      <WhyChooseUs onSchedule={openSchedule} />
      <Testimonials />
      <StatsBand />
      <Faq />
      <CtaSection onSchedule={openSchedule} />
    </>
  );
}
